/**Dependecies */
import React  from "react";
import {
  Modal,
  Button,
} from "react-bootstrap";
/**Styles */
import "../styles/components/header.scss";

/**Componente para renderizar el header*/
export const ModalHabs = ({children, handleShow, handleClose, title, bgBody, sizeModal}) => {

  return (
    <>
      {/**Contenedor numeros telefonicos */}
      <Modal
        show={handleShow}
        onHide={handleClose}
        centered
        className="modal-header"
        size={sizeModal}
      >
       
        <Modal.Header className={bgBody}>
        
          <Modal.Title className="w-100">{title}</Modal.Title>
          <div className="w-auto text-end">

          <Button
            onClick={handleClose}
            style={{ width: "auto", fontSize: "14px" }}
            className="bg-secondary border-0 text-end"
          >
            Cerrar
          </Button>
          </div>

        </Modal.Header>
        <Modal.Body className={bgBody}>
            {children}
        </Modal.Body>
      </Modal>
    </>
  );
};
